export default "__VITE_ASSET__B2w5krUF__"